
import { BatteryFull, BatteryMedium, BatteryLow } from "lucide-react";
export const BatteryIcon = ({ value }) => {
      if (value >= 80) {
            return <BatteryFull size={20} color="green" />;
      } else if (value >= 40) {
            return <BatteryMedium size={20} color="orange" />;
      } else {
            return <BatteryLow size={20} color="red" />;
      }
};
